"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTreeItem = exports.BmTreeItem = exports.cancelEvent = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmIcons = require("../bm-icons");

var _utils = require("../utils");

var _bmTreeModel = require("./bm-tree-model");

var _bmTreeStore = require("./bm-tree-store");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"subtitle\">", "</span>"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<div\n\t\t\t\t\tdraggable=\"", "\"\n\t\t\t\t\t@dragstart=\"", "\"\n\t\t\t\t\tclass=\"item-wrapper\">\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t\t<a\n\t\t\t\t\t\thref=\"", "\"\n\t\t\t\t\t\tclass=\"item-name\"\n\t\t\t\t\t\taria-label=\"", "\"\n\t\t\t\t\t\ttabindex=\"-1\">\n\t\t\t\t\t\t<span class=\"name\" data-qe-id=\"", "\">", "</span>\n\t\t\t\t\t\t", "\n\t\t\t\t\t</a>\n\t\t\t\t\t", "\n\t\t\t\t</div>\n\t\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t\t<span\n\t\t\t\t\t\tclass=\"", " ", "\"\n\t\t\t\t\t\ttabindex=\"", "\"\n\t\t\t\t\t\tstyle=\"--icon-color: ", "\"\n\t\t\t\t\t\ttitle=\"", "\"\n\t\t\t\t\t\taria-label=\"", "\"\n\t\t\t\t\t\t@click=\"", "\"\n\t\t\t\t\t>\n\t\t\t\t\t\t", "\n\t\t\t\t\t</span>\n\t\t\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<button class=\"expand-button\"\n\t\t\t\t\t\t\taria-label=\"", " ", "\"\n\t\t\t\t\t\t\taria-hidden=\"", "\"\n\t\t\t\t\t\t\taria-expanded = \"", "\"\n\t\t\t\t\t\t\ttabindex=\"-1\"\n\t\t\t\t\t\t\t@keydown = \"", "\"\n\t\t\t\t\t\t\t@click=\"", "\">\n\t\t\t\t", "\n\t\t\t\t</button>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<button class=\"checkbox-button\"\n\t\t\t\t\t\t\t\taria-hidden=\"", "\"\n\t\t\t\t\t\t\t\trole=\"checkbox\"\n\t\t\t\t\t\t\t\taria-checked=\"", "\"\n\t\t\t\t\t\t\t\ttabindex=\"", "\"\n\t\t\t\t\t\t\t\t@click=\"", "\">\n\t\t\t\t\t", "\n\t\t\t\t</button>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 30px;\n\t\theight: var(--bm-tree-item-height, 30px);\n\t\twidth: auto;\n\t\twidth: var(--bm-tree-item-width, auto);\n\t\tfont-size: 16px;\n\t\tfont-size: var(--bm-tree-item-font-size, 16px);\n\t\tcolor: #212121;\n\t\tborder: none;\n\t\tborder: var(--bm-tree-item-border);\n\t\tborder-left: 3px solid transparent;\n\t\tcursor: pointer;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t\tfont-weight: normal;\n\t\ttext-decoration: var(--bm-tree-item-text-decoration, none);\n\t\tcolor: var(--bm-tree-item-color, black);\n\t\toverflow: hidden;\n\t\tbackground: #ffffff;\n\t\tbox-sizing: border-box;\n\t\tpadding-right: var(--bm-tree-item-padding-right, 7px);\n\t}\n\t:host(:focus),\n\t:host(.drag-over) {\n\t\toutline: 1px dotted #212121;\n\t}\n\t:host .expand-button:focus,\n\t:host .checkbox-button:focus,\n\t:host .item-name:focus,\n\t:host .left-icon:focus,\n\t:host .right-icon:focus {\n\t\toutline: 1px dotted #212121;\n\t}\n\t:host(:not(.no-select):hover),\n\t:host(.selected) {\n\t\tbackground: #f4f5f7;\n\t\tbackground: var(--background-color, #f4f5f7);\n\t\tborder-left-color: #ff8000;\n\t\tborder-left-color: var(--theme-color, #ff8000);\n\t}\n\t:host(.no-select) {\n\t\tcursor: default;\n\t}\n\t:host(.selected) {\n\t\tfont-weight: 700;\n\t}\n\t:host a.item-name {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t\ttext-decoration: var(--bm-tree-item-text-decoration, none);\n\t\tcolor: var(--bm-tree-item-color, black);\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\t:host a.item-name .subtitle {\n\t\tcolor: rgb(102, 102, 102);\n\t\tfont-size: 12px;\n\t\tfont-style: italic;\n\t\tline-height: 16px;\n\t}\n\t:host .expand-button,\n\t:host .checkbox-button {\n\t\twidth: 20px;\n\t\tmin-width: 20px;\n\t\theight: 20px;\n\t\theight: calc(var(--tree-item-height, 30px) * 0.6);\n\t\tpadding: 0;\n\t\tmargin-right: 15px;\n\t\tborder: none;\n\t\tfont-size: 16px;\n\t\tcursor: pointer;\n\t\tbackground: transparent;\n\t}\n\t:host svg {\n\t\twidth: auto;\n\t\theight: 100%;\n\t}\n\t:host .left-icon {\n\t\tdisplay: inline-block;\n\t\theight: 20px;\n\t\theight: calc(var(--tree-item-height, 30px) * 0.6);\n\t\twidth: auto;\n\t\tmargin-right: 15px;\n\t}\n\t:host .left-icon svg {\n\t\tfill: var(--icon-color, #212121);\n\t}\n\t:host .right-icon svg {\n\t\tfill: var(--icon-color, #212121);\n\t}\n\t:host .right-icon {\n\t\tdisplay: inline-block;\n\t\theight: 20px;\n\t\theight: calc(var(--tree-item-height, 30px) * 0.6);\n\t\twidth: auto;\n\t\tmargin-left: 15px;\n\t}\n\t:host .hidden {\n\t\tdisplay: none;\n\t}\n\t:host .item-wrapper {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\t:host .icon-button {\n\t\tborder: 1px solid #b2b2b8;\n\t\tborder-radius: 5px;\n\t\tpadding: 2px;\n\t}\n\t:host .icon-button:hover {\n\t\tborder-color: #212121;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var cancelEvent = function cancelEvent(e) {
  e.preventDefault();
};

exports.cancelEvent = cancelEvent;
var style = (0, _element.css)(_templateObject());

var BmTreeItem = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmTreeItem, _BlueElement);

  var _super = (0, _createSuper2.default)(BmTreeItem);

  (0, _createClass2.default)(BmTreeItem, null, [{
    key: "is",
    get: function get() {
      return 'bm-tree-item';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: true,
          reflect: true
        },
        subtitle: {
          type: String,
          attribute: true,
          reflect: true
        },
        allowSelect: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        showCheckboxes: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        showItemCheckbox: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        selectAsCheck: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        layer: {
          type: Number,
          attribute: true,
          reflect: true
        },
        leftIcon: {
          type: Object,
          attribute: false,
          reflect: false
        },
        rightIcon: {
          type: Object,
          attribute: false,
          reflect: false
        },
        href: {
          type: String,
          attribute: true,
          reflect: true
        },
        subItems: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        selected: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        checked: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        indeterminate: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        store: {
          type: Object,
          attribute: false,
          reflect: false
        },
        allowDropInto: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        allowItemDrag: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        index: {
          type: Number,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmTreeItem() {
    var _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9;

    var _this;

    (0, _classCallCheck2.default)(this, BmTreeItem);
    _this = _super.call(this);
    _this.allowSelect = void 0;
    _this.name = void 0;
    _this.subtitle = void 0;
    _this.showCheckboxes = void 0;
    _this.showItemCheckbox = void 0;
    _this.selectAsCheck = void 0;
    _this.layer = void 0;
    _this.leftIcon = void 0;
    _this.rightIcon = void 0;
    _this.href = void 0;
    _this.expanded = void 0;
    _this.subItems = void 0;
    _this.selected = void 0;
    _this.checked = void 0;
    _this.visible = void 0;
    _this.indeterminate = void 0;
    _this.store = void 0;
    _this.allowDropInto = void 0;
    _this.allowItemDrag = void 0;
    _this.parentId = void 0;
    _this.movedItem = void 0;
    _this.index = void 0;
    _this.treeStore = void 0;

    _this.handleStateChange = function (e) {
      var _context;

      if ((0, _includes.default)(_context = e.detail).call(_context, _this.id)) {
        _this.requestUpdate(e.type).catch(console.error);
      }
    };

    _this.handleDragEnter = function (e) {
      e.preventDefault();

      if (e.dataTransfer && !_this.allowDropInto) {
        e.dataTransfer.dropEffect = 'notAllowed';
      } else if (e.dataTransfer) {
        e.dataTransfer.dropEffect = 'copy';

        _this.classList.add('drag-over');
      }
    };

    _this.handleDragLeave = function (e) {
      e.preventDefault();

      _this.classList.remove('drag-over');
    };

    _this.removeDragData = function (e) {
      var _e$dataTransfer;

      if ((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : _e$dataTransfer.items) {
        e.dataTransfer.items.clear();
      } else if (e.dataTransfer) {
        e.dataTransfer.clearData();
      }
    };

    _this.handleDrop = function (e) {
      e.preventDefault();

      _this.classList.remove('drag-over');

      if (!_this.allowDropInto) {
        return;
      }

      var treeState = _this.treeStore.get(_this.id);

      if (treeState && e.dataTransfer) {
        var treeItem = treeState.details;
        var files = [];

        var _iterator = (0, _createForOfIteratorHelper2.default)(e.dataTransfer.items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var file = item.getAsFile();

            if (file) {
              files.push(file);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (files.length > 0) {
          _this.dispatchEvent(new CustomEvent('dropped-external-file', {
            detail: {
              treeItem: treeItem,
              files: files
            }
          }));
        } else {
          var transferData = JSON.parse(e.dataTransfer.getData('text/plain'));
          _this.movedItem = transferData.id;

          var oldParent = _this.treeStore.get(transferData.parentId);

          var newParent = _this.treeStore.get(_this.id);

          if (oldParent && newParent) {
            var emitData = {
              treeItem: treeItem,
              oldParent: oldParent.details,
              newParent: newParent.details
            };

            _this.dispatchEvent(new CustomEvent('dropped-moved-item', {
              detail: emitData
            }));
          }
        }

        _this.removeDragData(e);
      } else {
        _this.dispatchEvent(new CustomEvent('error', {
          detail: _bmTreeModel.TreeErrorActions.Drag
        }));
      }
    };

    _this.handleDragStart = function (e) {
      if (!_this.allowItemDrag) {
        return;
      }

      e.stopPropagation();

      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move';
        var data = (0, _stringify.default)({
          id: _this.id,
          name: _this.name,
          parentId: _this.parentId,
          index: _this.index
        });
        e.dataTransfer.setData('text/plain', data);
      }
    };

    _this.allowSelect = true;
    _this.name = '';
    _this.subtitle = null;
    _this.showCheckboxes = false;
    _this.showItemCheckbox = false;
    _this.selectAsCheck = false;
    _this.layer = 0;
    _this.leftIcon = null;
    _this.rightIcon = null;
    _this.href = '';
    _this.expanded = false;
    _this.subItems = false;
    _this.selected = false;
    _this.checked = false;
    _this.indeterminate = false;
    _this.visible = false;
    _this.store = new _bmTreeStore.TreeStore();
    _this.allowItemDrag = false;
    _this.allowDropInto = false;
    _this.parentId = '';
    _this.movedItem = '';
    _this.index = 0;
    _this.treeStore = new _bmTreeStore.TreeStore();
    _this.handleItemClick = (0, _bind.default)(_context2 = _this.handleItemClick).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.handleCheckboxClick = (0, _bind.default)(_context3 = _this.handleCheckboxClick).call(_context3, (0, _assertThisInitialized2.default)(_this));
    _this.handleDragEnter = (0, _bind.default)(_context4 = _this.handleDragEnter).call(_context4, (0, _assertThisInitialized2.default)(_this));
    _this.handleDragLeave = (0, _bind.default)(_context5 = _this.handleDragLeave).call(_context5, (0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = (0, _bind.default)(_context6 = _this.handleDrop).call(_context6, (0, _assertThisInitialized2.default)(_this));
    _this.handleDragStart = (0, _bind.default)(_context7 = _this.handleDragStart).call(_context7, (0, _assertThisInitialized2.default)(_this));
    _this.updateTree = (0, _bind.default)(_context8 = _this.updateTree).call(_context8, (0, _assertThisInitialized2.default)(_this));
    _this.handleStateChange = (0, _bind.default)(_context9 = _this.handleStateChange).call(_context9, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmTreeItem, [{
    key: "updateTree",
    value: function updateTree() {
      this.treeStore.set(this.movedItem, {
        move: this.id
      });
    }
  }, {
    key: "selectClick",
    value: function selectClick(event) {
      var button = event.button,
          buttons = event.buttons,
          altKey = event.altKey,
          ctrlKey = event.ctrlKey,
          metaKey = event.metaKey,
          shiftKey = event.shiftKey,
          clientX = event.clientX,
          clientY = event.clientY,
          pageX = event.pageX,
          pageY = event.pageY,
          screenX = event.screenX,
          screenY = event.screenY;
      var eventData = {
        button: button,
        buttons: buttons,
        altKey: altKey,
        ctrlKey: ctrlKey,
        metaKey: metaKey,
        shiftKey: shiftKey,
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY,
        screenX: screenX,
        screenY: screenY
      };
      this.dispatchEvent(new CustomEvent('select', {
        detail: eventData
      }));
    }
  }, {
    key: "selectKeyDown",
    value: function selectKeyDown(event) {
      var eventData = {
        isExpandIconKeyDown: true,
        target: event.target
      };
      this.dispatchEvent(new CustomEvent('select', {
        detail: eventData
      }));
    }
  }, {
    key: "handleIconClick",
    value: function handleIconClick(e, callback) {
      if (callback) {
        e.stopPropagation();
        callback();
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      if (this.allowSelect) {
        this.selected = !this.selected;
        this.treeStore.set(this.id, {
          selected: this.selected
        });
        this.selectClick(e);
        this.requestUpdate('select').catch(console.error);

        if (this.href) {
          e.preventDefault();
        }
      }
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(e) {
      e.stopPropagation();

      if (this.showItemCheckbox) {
        this.checked = !this.checked && !this.indeterminate;
        this.treeStore.set(this.id, {
          checked: this.checked
        });
        this.dispatchEvent(new CustomEvent('check', {
          detail: this.checked
        }));
        this.requestUpdate('checked').catch(console.error);
      }
    }
  }, {
    key: "toggleExpandKeyDown",
    value: function toggleExpandKeyDown(event) {
      event.stopPropagation();

      if (event && (event.code === _utils.KeyCode.Enter || event.code === _utils.KeyCode.Space)) {
        event.preventDefault();
        this.toggleExpand(event);
      }
    }
  }, {
    key: "handleExpandClick",
    value: function handleExpandClick(e) {
      e.stopPropagation();
      this.toggleExpand(e);
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand(e) {
      if (this.subItems) {
        this.expanded = !this.expanded;
        this.treeStore.set(this.id, {
          expanded: this.expanded
        });
        var treeState = this.treeStore.get(this.id);
        this.dispatchEvent(new CustomEvent('toggle-expand', {
          detail: {
            expanded: this.expanded,
            treeItem: treeState === null || treeState === void 0 ? void 0 : treeState.details,
            target: e.target
          }
        }));
        this.requestUpdate('expanded').catch(console.error);
      } else {
        if (e instanceof MouseEvent) {
          this.selectClick(e);
        }

        if (e instanceof KeyboardEvent) {
          this.selectKeyDown(e);
        }
      }
    }
  }, {
    key: "removeStoreListeners",
    value: function removeStoreListeners(store) {
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Visible, this.handleStateChange);
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Checked, this.handleStateChange);
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Selected, this.handleStateChange);
    }
  }, {
    key: "addStoreListeners",
    value: function addStoreListeners(store) {
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Visible, this.handleStateChange);
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Checked, this.handleStateChange);
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Selected, this.handleStateChange);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeItem.prototype), "connectedCallback", this).call(this);
      this.style.paddingLeft = "".concat(this.layer * 20 + 7, "px");

      if (this.layer && this.layer !== 0 && !this.visible) {
        this.classList.add('hidden');
      } else {
        this.classList.remove('hidden');
      }

      if (!this.allowSelect) {
        this.classList.add('no-select');
      }

      this.addStoreListeners(this.store);
      this.addEventListener('click', this.handleItemClick);
      this.addEventListener('drop', this.handleDrop);
      this.addEventListener('dragenter', this.handleDragEnter);
      this.addEventListener('dragover', cancelEvent);
      this.addEventListener('dragleave', this.handleDragLeave);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeItem.prototype), "disconnectedCallback", this).call(this);
      this.removeStoreListeners(this.store);
      this.removeEventListener('click', this.handleItemClick);
      this.removeEventListener('drop', this.handleDrop);
      this.removeEventListener('dragenter', this.handleDragEnter);
      this.removeEventListener('dragover', cancelEvent);
      this.removeEventListener('dragleave', this.handleDragLeave);
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      if (changedProps.has('store') && this.store) {
        this.removeStoreListeners(this.treeStore);
        this.treeStore = this.store;
        this.addStoreListeners(this.treeStore);
      }

      if (changedProps.has('layer')) {
        this.style.paddingLeft = "".concat(this.layer * 20 + 7, "px");
      }

      if (changedProps.has('itemState') || changedProps.has(_bmTreeModel.TreeStateChangeType.Visible) || changedProps.has('expanded') || changedProps.has(_bmTreeModel.TreeStateChangeType.Selected) || changedProps.has(_bmTreeModel.TreeStateChangeType.Checked) || changedProps.has('parentId')) {
        var itemState = this.store.get(this.id);
        this.visible = itemState ? itemState.visible : false;
        this.expanded = itemState ? itemState.expanded : false;
        this.selected = itemState ? itemState.selected : false;
        this.checked = itemState ? itemState.checked : false;
        this.indeterminate = itemState ? itemState.indeterminate : false;
        this.parentId = itemState ? itemState.parentId : '';

        if (this.selected) {
          this.classList.add('selected');
        } else {
          this.classList.remove('selected');
        }

        if (this.layer && this.layer !== 0 && !this.visible) {
          this.classList.add('hidden');
        } else {
          this.classList.remove('hidden');
        }
      }

      return changedProps.size > 0;
    }
  }, {
    key: "renderExpandIcons",
    value: function renderExpandIcons(expanded) {
      if (expanded) {
        return (0, _bmIcons.iconForType)(_bmIcons.IconType.MinusPlain);
      }

      return (0, _bmIcons.iconForType)(_bmIcons.IconType.PlusPlain);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {
      if (this.checked) {
        return (0, _bmIcons.iconForType)(_bmIcons.IconType.CheckboxFilled);
      }

      if (this.indeterminate) {
        return (0, _bmIcons.iconForType)(_bmIcons.IconType.Collapse);
      }

      return (0, _bmIcons.iconForType)(_bmIcons.IconType.Checkbox);
    }
  }, {
    key: "renderCheckboxButton",
    value: function renderCheckboxButton() {
      return this.html(_templateObject2(), !this.showItemCheckbox, this.checked, this.showItemCheckbox ? 0 : -1, this.handleCheckboxClick, this.showItemCheckbox ? this.renderCheckbox() : null);
    }
  }, {
    key: "renderExpandButton",
    value: function renderExpandButton() {
      return this.html(_templateObject3(), this.expanded ? 'collapse' : 'expand', this.name, !this.subItems, this.expanded, this.toggleExpandKeyDown, this.handleExpandClick, this.subItems ? this.renderExpandIcons(this.expanded) : null);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(iconArray, side) {
      var _this2 = this;

      return (0, _repeatInstanceProperty(_element))(iconArray, function (i) {
        return i;
      }, function (i) {
        var _i$tooltip, _i$tooltip2;

        var sideClass = side === 'left' ? 'left-icon' : 'right-icon';
        var callbackClass = i.callback ? 'icon-button' : '';
        return _this2.html(_templateObject4(), sideClass, callbackClass, i.callback ? 0 : -1, i.color, _this2.subItems ? (_i$tooltip = i.tooltip) !== null && _i$tooltip !== void 0 ? _i$tooltip : _this2.name : '', _this2.subItems ? (_i$tooltip2 = i.tooltip) !== null && _i$tooltip2 !== void 0 ? _i$tooltip2 : _this2.name : '', function (e) {
          return _this2.handleIconClick(e, i.callback);
        }, (0, _bmIcons.iconForType)(i.name));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hasLeftIcon = Boolean(this.leftIcon && this.leftIcon.length > 0);
      var hasRightIcon = Boolean(this.rightIcon && this.rightIcon.length > 0);
      var treeState = this.treeStore.get(this.id);
      var qeId = treeState ? treeState.dataQeId : undefined;
      return this.html(_templateObject5(), this.allowItemDrag, this.handleDragStart, this.renderExpandButton(), this.showCheckboxes ? this.renderCheckboxButton() : null, hasLeftIcon ? this.renderIcon(this.leftIcon, 'left') : null, (0, _utils.ifNotEmpty)(this.href), this.name, (0, _element.ifDefined)(qeId), this.name, this.subtitle ? this.html(_templateObject6(), this.subtitle) : null, hasRightIcon ? this.renderIcon(this.rightIcon, 'right') : null);
    }
  }]);
  return BmTreeItem;
}(_element.BlueElement);

exports.BmTreeItem = BmTreeItem;

var registerTreeItem = function registerTreeItem() {
  return (0, _element.register)(BmTreeItem);
};

exports.registerTreeItem = registerTreeItem;
